import { memo, useCallback, useMemo } from "react";

import { FeatureIslandCategoryQuestionForMain } from "@/components/features/_layouts/island/main-with-category/components/category-main-question";
import { QuestionSectionWrapper } from "@/components/features/items/edit/_shared/ui/components/system/question/_layouts/item-wrapper";

import { CheckboxField } from "@/components/ui/form/fields/check-box-field/check-box";
import { InputNumberField } from "@/components/ui/form/fields/input-field/input-number";

type Props = {
	isCoSleepingKidsPriceActive: boolean;
	amount: number | undefined;
	amountError: string | undefined;
	onChangeIsCoSleepingKidsPriceActive: (value: boolean) => void;
	onChangeCoSleepingKidsPrice: (value: number | undefined) => void;
};

export const QuestionCoSleeping = memo(
	({
		isCoSleepingKidsPriceActive,
		amount,
		amountError,
		onChangeIsCoSleepingKidsPriceActive,
		onChangeCoSleepingKidsPrice,
	}: Props) => {
		const hasErrorOfAmount = useMemo(() => amountError !== undefined, [amountError]);

		const handleChangeIsCoSleepingKidsPriceActive = useCallback(
			(value: boolean) => {
				onChangeIsCoSleepingKidsPriceActive(value);
			},
			[onChangeIsCoSleepingKidsPriceActive],
		);

		const handleChangeCoSleepingKidsPrice = useCallback(
			(value: number | undefined) => {
				onChangeCoSleepingKidsPrice(value);
			},
			[onChangeCoSleepingKidsPrice],
		);

		return (
			<div className="flex flex-col gap-y-6">
				<FeatureIslandCategoryQuestionForMain
					required={false}
					title="添い寝の子供の料金"
					guide="プラン独自の添い寝の子供料金を設定できます。<br/>ここでの設定はホテルポリシーで設定した添い寝の子供料金より優先されます。"
					hasError={false}
					isEdited={isCoSleepingKidsPriceActive}
					inputChildren={
						<CheckboxField
							value={isCoSleepingKidsPriceActive}
							label="添い寝の子供の料金を設定する"
							handleChange={handleChangeIsCoSleepingKidsPriceActive}
							errorMessage={undefined}
						/>
					}
				/>

				{isCoSleepingKidsPriceActive ? (
					<FeatureIslandCategoryQuestionForMain
						required={false}
						title=""
						isEdited={false}
						hasError={hasErrorOfAmount}
						inputChildren={
							<QuestionSectionWrapper>
								<p>添い寝の子供一人当たり</p>
								<InputNumberField
									value={amount}
									handleInput={handleChangeCoSleepingKidsPrice}
									errorMessage={amountError}
								/>
								<p className="text-right">円（税込）</p>
							</QuestionSectionWrapper>
						}
					/>
				) : (
					<></>
				)}
			</div>
		);
	},
);

QuestionCoSleeping.displayName = "QuestionCoSleeping";
